import { useMutationCommon } from "hooks/useCRUD";
import callbackSapService from "services/CallbackSapService";

// Lấy thông tin hóa đơn để hiển thị trên modal gửi callback về SAP
export const useGetCallbackSapInfo = ({
  onSuccess = undefined,
  onError = undefined,
}) => {
  const { mutation } = useMutationCommon({
    mutationFn: callbackSapService.getCallbackSapInfo,
    onSuccess,
    onError,
    translation: ["invoicePos"],
    translationAction: "getCallbackSapInfo",
    target: "invoices",
    isNotifyError: true,
    isNotifySuccess: false,
  });

  return mutation;
};

// Gửi callback về SAP
export const useSendCallbackSap = ({
  onSuccess = undefined,
  onError = undefined,
}) => {
  const { mutation } = useMutationCommon({
    mutationFn: callbackSapService.sendCallbackSap,
    onSuccess,
    onError,
    translation: ["invoicePos"],
    translationAction: "sendCallbackSap",
    target: "invoices",
    isNotifyError: true,
    isNotifySuccess: true,
  });

  return mutation;
};
